
import React from "react";
import "../../Styles/certified/novac.css";

export default function Novac() {
  return (
    <>
      <div className="novac-details-section">
        <div className="novac-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="novac-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="novac-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="novac-badge"
            />
            <div className="novac-company-names">
              <a href="https://www.novactech.com" target="_blank" rel="noopener noreferrer"><img src="/assets/novac/novac.png" alt="Novac.png" className="novac-company-logo" /></a>
              <h1 className="novac-full-name">
                Novac Technology Solutions Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="novac-details-right">
            <img
              src="/assets/novac/1.jpg"
              alt="Novac Office"
              className="novac-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="novac-description">
          <h2>
            Why Novac Technology Solutions Private Limited is a Outstanding Workplaces
          </h2>
          <p>
            Novac Technology Solutions is driven by a passion for creativity, enabling us to deliver cutting-edge solutions across diverse industries. 
            Our expertise spans Financial Services, Insurance, Digital Learning, and Immersive Technology, empowering businesses on their path to embracing the transformation. 
            Guided by an unwavering commitment to excellence, we harness emerging technologies to help our clients optimize costs, enhance quality, and secure competitive advantages in a rapidly changing marketplace. 
            Our values, rooted in integrity and nurturing enduring relationships, inspire us to not just meet, but exceed expectations, fostering steadfast client loyalty. 
            And our offerings are characterized by efficiency, integrity, and a forward-looking perspective, poised to tackle the challenges of the future.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="novac-info-cards">
          <div className="novac-info-card">
            <div className="novac-info-title">COMPANY SIZE</div>
            <div className="novac-info-value">3800 Employees</div>
          </div>
          <div className="novac-info-card">
            <div className="novac-info-title">INDUSTRY</div>
            <div className="novac-info-value">Information Technology</div>
          </div>
          <div className="novac-info-card">
            <div className="novac-info-title">CONNECT</div>
            <div className="novac-info-icons">
              <span className="novac-icon-round">
                <a href="https://www.novactech.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="novac-icon-round">
                <a href="https://in.linkedin.com/company/novactech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="novac-icon-round">
                <a href="https://www.facebook.com/NovacTechnology" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="novac-icon-round">
                <a href="https://twitter.com/NovacTechnology" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="novac-info-card">
            <div className="novac-info-title">LOCATION (HQ)</div>
            <div className="novac-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="novac-recognition-section">
          <h2 className="novac-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="novac-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="novac-recognition-image"
            />
          </div>
          <div className="novac-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Novac Section */}
        <div className="novac-life-section">
          <h2 className="novac-life-title">
            Life at Novac Technology Solutions Private Limited
          </h2>
          <div className="novac-life-gallery">
            <div className="novac-life-col">
              <img src="/assets/novac/4.jpg" alt="Office 1" className="novac-life-img" />
              <img src="/assets/novac/5.jpg" alt="Meeting 1" className="novac-life-img" />
            </div>
            <div className="novac-life-col novac-life-center">
              <img src="/assets/novac/3.jpg" alt="Main Office" className="novac-life-img novac-life-img-large" />
            </div>
            <div className="novac-life-col">
              <img src="/assets/novac/6.jpg" alt="Office 2" className="novac-life-img" />
              <img src="/assets/novac/2.jpg" alt="Meeting 2" className="novac-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}